import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/icon-white-success.png'
import _imports_1 from '../../assets/image/accident-icon-black.png'
import _imports_2 from '../../assets/image/fire-icon-black.png'
import _imports_3 from '../../assets/image/water-icon-black.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-486ce91c")

_pushScopeId("data-v-486ce91c")
const _hoisted_1 = { class: "ui__brandIntroduction_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_head" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_two" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_two_item" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" 90天回购保障 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_two_item" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" 重要部件保修 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_two_item" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" 10大类477项精细检测 ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_text" }, "排除重大事故、火烧、泡水车风险，车况透明，安心购车"),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitems" }, [
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitem" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_1,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitem-msg" }, "非重大事故车")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitem" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_2,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitem-msg" }, "非火烧车")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitem" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_3,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_three_checkitem-msg" }, "非泡水车")
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_four" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_four_title" }, [
    /*#__PURE__*/_createVNode("span", null, "90天"),
    /*#__PURE__*/_createTextVNode("错检回购保障 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_four_content" }, " 通过268V实车检测且【新车指导价100万以内的车辆】，检测保障激活后，自过户完成之日起90天内，若您发现被检测车辆为重大事故、火烧、泡水车，而检测报告未准确反映的，268V负责对该车辆进行差价赔付或按交易价回购。 ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five_title" }, [
    /*#__PURE__*/_createVNode("span", null, "268V"),
    /*#__PURE__*/_createTextVNode("专注车况检测18年 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five_text" }, "从2004年建立数据库开始，268V从事专业二手车检测已有18年时间"),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five_img" }),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five_content" }, [
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five_section" }, "268V是汽车产业互联网平台大搜车旗下二手车专业检测品牌，拥有享誉行业的统一车况语言，开辟了中国二手车检测先河，为二手车交易更便捷提供了有保障、值得信赖的标准体系。268V品牌下现有“买车无忧检”与“商家交易检”两大检测系列产品和“买车无忧保”系列质保产品。"),
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_five_section" }, "大搜车是中国领先的汽车产业互联网平台，自2012年创立以来，累计获得阿里巴巴集团、蚂蚁集团等机构超过12亿美元投资。目前，大搜车已经构建起涵盖软件与SaaS服务、新车与二手车业务在内的汽车流通产业生态体系。2020年，大搜车入选“2020中国新经济企业500强”、“2020全球独角兽企业500强”榜单。")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_six" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_six_item" }, [
    /*#__PURE__*/_createVNode("div", { class: "num-msg" }, "3000000+"),
    /*#__PURE__*/_createVNode("div", { class: "text-msg" }, "累计检测车辆"),
    /*#__PURE__*/_createVNode("div", { class: "vertical-line" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_six_item" }, [
    /*#__PURE__*/_createVNode("div", { class: "num-msg" }, "34000+"),
    /*#__PURE__*/_createVNode("div", { class: "text-msg" }, "累计培养检测师"),
    /*#__PURE__*/_createVNode("div", { class: "vertical-line" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_six_item" }, [
    /*#__PURE__*/_createVNode("div", { class: "num-msg" }, "95%"),
    /*#__PURE__*/_createVNode("div", { class: "text-msg" }, "覆盖车型")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_standard" }, [
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_standard_img" }),
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_standard_content" }, [
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_standard_title" }, [
        /*#__PURE__*/_createVNode("h4", null, "268V标准化"),
        /*#__PURE__*/_createVNode("h4", null, "二手车检测评估系统")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_standard_text" }, " 根据数千辆各类事故车的检测数据和查勘修复记录，自主研发的事故痕迹采集及车辆历史事故严重程度判定系统。这是国内第一个根据量化的检测数据，准确判定车辆历史事故严重程度并具有可执行性的二手车标准检测系统。 ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_tool" }, [
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_tool_img" }),
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_tool_content" }, [
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_tool_title" }, [
        /*#__PURE__*/_createVNode("h4", null, "智能检测工具")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_tool_text" }, " 漆膜厚度测试仪、OBD故障检测仪等设备的检测结果数据直连数据中心，排除人为干扰，一键生成检测报告。 ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval" }, [
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_img" }, [
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_item" }, [
        /*#__PURE__*/_createVNode("div", { class: "introduce-icon5" }),
        /*#__PURE__*/_createVNode("div", { class: "approval-img-text" }, [
          /*#__PURE__*/_createTextVNode("ISO9001管理体系"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("权威机构认证")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_item" }, [
        /*#__PURE__*/_createVNode("div", { class: "introduce-icon4" }),
        /*#__PURE__*/_createVNode("div", { class: "approval-img-text" }, [
          /*#__PURE__*/_createTextVNode("ISO9001管理体系"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("符合中国认可标准")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_item" }, [
        /*#__PURE__*/_createVNode("div", { class: "introduce-icon1" }),
        /*#__PURE__*/_createVNode("div", { class: "approval-img-text" }, [
          /*#__PURE__*/_createTextVNode("汽车维修行业"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("协会会员单位")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_item" }, [
        /*#__PURE__*/_createVNode("div", { class: "introduce-icon2" }),
        /*#__PURE__*/_createVNode("div", { class: "approval-img-text" }, [
          /*#__PURE__*/_createTextVNode("汽车流通协会"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("行认证")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_item" }, [
        /*#__PURE__*/_createVNode("div", { class: "introduce-icon3" }),
        /*#__PURE__*/_createVNode("div", { class: "approval-img-text" }, [
          /*#__PURE__*/_createTextVNode("荣获国家发"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("明专利268V")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_content" }, [
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_title" }, [
        /*#__PURE__*/_createVNode("h4", null, "权威机构授予资质"),
        /*#__PURE__*/_createVNode("h4", null, "专业实力备受认可")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_seven_approval_text" }, [
        /*#__PURE__*/_createTextVNode(" • 汽车维修行业协会(CAMRA)会员单位"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode(" • 汽车流通协会(CADA)行认证"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode(" • 荣获2项国家发明专利"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode(" • 获得ISO9001质量管理体系认证 ")
      ])
    ])
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_eight" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_eight_title" }, "400+检测网点遍布全国"),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_eight_text" }, "2021年，268V车辆检测服务将覆盖全国各省的三线以上城市及部分四五线城市，共计400+检测网点。"),
  /*#__PURE__*/_createVNode("div", { class: "ui__brandIntroduction_eight_phone" }, "检测热线：400-808-3718")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
})